module.exports = require('./lib/styleable')


//////////////////
// WEBPACK FOOTER
// ./~/react-styleable/index.js
// module id = KJcn
// module chunks = 0